import {Component, Input, OnInit, OnChanges, SimpleChanges, AfterViewInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-ckm-simulation-maps',
  templateUrl: './ckm-simulation-maps.component.html',
  styleUrls: ['./ckm-simulation-maps.component.scss']
})
export class CkmSimulationMapsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() maps: any[] = [];

  displayedColumns: string[] = [
    'previousMap',
    'version',
    'createdAt',
    'status',
    'action'
  ];

  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.maps);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.maps && !changes.maps.firstChange) {
      this.dataSource.data = this.maps;
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
